import React from 'react'
import ReactTooltip from 'react-tooltip'
import {Link} from "react-router-dom";

export default class Header extends React.Component{

  handleClickOpen(unit_id){
    this.props.toggleSearchMethod("")
    if(this.props.toggleMenu){
      this.props.toggleMenuMethod()
    }
    const { handleModalOpen } = this.props
    handleModalOpen(unit_id)
  }

  handleClickClose(){
    const { handleModalClose } = this.props
    handleModalClose()
  }

  handleClickToggleMenu(){
    this.props.toggleMenuMethod()
  }

  handleClickToggleResult(){
    this.props.toggleResultMethod()
  }

  handleClickToggleSearch(e){
    this.props.toggleSearchMethod(e.target.value)
  }

  handleClickToggleGender(){
    this.props.toggleGenderMethod()
  }

  handleClickSwitchPage(page){
    if(this.props.toggleResult){
      this.props.toggleResultMethod()
    }
    if(this.props.toggleMenu){
      this.props.toggleMenuMethod()
    }
    this.props.switchPageMethod(page)
  }

  render(){
    const {page, toggleMenu, toggleResult, toggleSearch, dataSearchResult, nickname, gender, lsc_status, lsc_result, special_kit_codes} = this.props

    const qvcBigDiscovery = special_kit_codes.indexOf('big_discovery') >= 0 ? (
        <li><Link to={{
          pathname: "/add10",
          state: {referer: "/header"}
        }} onClick={this.handleClickSwitchPage.bind(this, "BigDiscovery")}>特別追加10項目</Link>
        </li>
    ) : null;

    return(
      <div className={toggleMenu ? "main_header active" : "main_header"}>
        <div className="main_header_logo"><Link  to={{
          pathname: "/",
          state: { referer: "/" }
        }} ><span onClick={this.handleClickSwitchPage.bind(this, "Top")}><img src="image/genelifelogo.png" alt="" /></span></Link>
          <div className="spmenu">
            <div className={toggleMenu ? "spmenuin active" : "spmenuin"} onClick={this.handleClickToggleMenu.bind(this)}>
              <span/>
              <span/>
              <span/>
            </div>
          </div>
        </div>
        <ul className={toggleMenu ? "main_header_menu active" : "main_header_menu"}>
          <li className="main_header_person"><Link to={{
            pathname: "/",
            state: { referer: "/header" }
          }} onClick={this.handleClickSwitchPage.bind(this, "Top")} >{nickname}さんの検査結果</Link></li>
          {page === 'Top' ? (
          <li className="main_header_gender">
            <ul className="gender">
              <li className={gender === 'male' ? 'active' : ''}><a onClick={this.handleClickToggleGender.bind(this)}>男性</a></li>
              <li className={gender === 'female' ? 'active' : ''}><a onClick={this.handleClickToggleGender.bind(this)}>女性</a></li>
            </ul>
            <p className="gender_text"><a data-tip data-for='swich_gender'>性別切り替えについて</a></p>
            <ReactTooltip id='swich_gender' type='dark' effect='solid' place='bottom'>
              <div className="tooltip_gender">
                <br/>
                <h3>遺伝子検査結果の性別切替表示が可能になりました</h3>
                <br/>
                <p>
                この度、GeneLife2.0では遺伝子検査結果で、女性・男性の表示切り替えができるようになりました。<br />
                性別固有の検査項目や性別によって結果が異なる項目でも、それに関連する遺伝子が存在する場合には、<br />
                自分とは違う性別だった場合についても確認することができます。
                </p>
                <br/>
              </div>
            </ReactTooltip>
          </li>
          ) : ""}
          <li className="menu_results">
            <a onClick={this.handleClickToggleResult.bind(this)} >検査結果を見る</a>
            <ul className={toggleResult ? "menu_results_sub active" : "menu_results_sub"}>
              <li><Link  to={{
                pathname: "/disease",
                state: { referer: "/header" }
              }} onClick={this.handleClickSwitchPage.bind(this, "Disease")}>疾患カテゴリ</Link></li>
              <li><Link  to={{
                pathname: "/constitution",
                state: { referer: "/header" }
              }}onClick={this.handleClickSwitchPage.bind(this, "Constitution")}>体質カテゴリ</Link></li>
              <li><Link  to={{
                pathname: "/risklevel",
                state: { referer: "/header" }
              }} onClick={this.handleClickSwitchPage.bind(this, "Risklevel")}>リスクレベル</Link></li>
              {qvcBigDiscovery}
              <li><Link  to={{
                pathname: "/sevens",
                state: { referer: "/header" }
              }} onClick={this.handleClickSwitchPage.bind(this, "Sevens")}>七大生活習慣病</Link></li>
              <li><Link   to={{
                pathname: "/cancer",
                state: { referer: "/header" }
              }} onClick={this.handleClickSwitchPage.bind(this, "Cancer")}>がんのリスク評価</Link></li>
              {(lsc_status == "ok") ?
                 (lsc_result.length > 0) ?
              　　  <li><Link  to={{
                    pathname: "/lsc_content",
                    state: { referer: "/header" }
                  }}  onClick={this.handleClickSwitchPage.bind(this, "LscContent")}>ライフスタイル通信簿</Link></li>
                :
                   ""
              :
                ""
              }
            </ul>
          </li>
          <li className="menu_results_search">
            <div className="search_input"><input onClick={this.handleClickToggleSearch.bind(this)}　onChange={this.handleClickToggleSearch.bind(this)} type="text" name="" placeholder="検査項目名で検索" />
              <p className="searchbtn"><img src="image/search.png" alt="" /></p>
            </div>
            <ul className={toggleSearch ? "menu_results_sub active" : "menu_results_sub"}>
              {dataSearchResult.map((data) => {
                return <li key={data.id}><Link  to={{
                  pathname: "/detail",
                  state: { referer: "/header" }
                }} onClick={this.handleClickOpen.bind(this, data.id)}>{data.name}</Link></li>;
              })}
            </ul>
          </li>
          <li className="menu_help"><Link to={{
            pathname: "/help",
            state: { referer: "/header" }
          }} onClick={this.handleClickSwitchPage.bind(this, "Help")}>ヘルプ</Link></li>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js